import { render, staticRenderFns } from "./editPrinterRule.vue?vue&type=template&id=435ef9ed"
import script from "./editPrinterRule.vue?vue&type=script&lang=js"
export * from "./editPrinterRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports